import { PureComponent } from 'react';

import PropTypes from 'prop-types';

import { TimeSlotsList } from '../time-slots-list';

import styles from './TimeSlotSectionContent.scss';

export class TimeSlotSectionContent extends PureComponent {
  render() {
    const {
      slots,
      displayedSectionName,

      selectedTimeSlot,
      selectTimeSlot,
    } = this.props;

    return (
      <ul className={styles.TimeSlotSectionContent} data-testid="TimeSlotSectionContent">
        {Object.entries(slots).map(
          ([sectionName, sectionSlots]) =>
            sectionName === displayedSectionName && (
              <TimeSlotsList
                key={sectionName}
                sectionName={sectionName}
                slots={sectionSlots}
                selectedTimeSlot={selectedTimeSlot}
                selectTimeSlot={selectTimeSlot}
              />
            ),
        )}
      </ul>
    );
  }
}

TimeSlotSectionContent.propTypes = {
  slots: PropTypes.shape({}).isRequired,
  displayedSectionName: PropTypes.string.isRequired,
  selectTimeSlot: PropTypes.func.isRequired,
  selectedTimeSlot: PropTypes.shape({
    from: PropTypes.number.isRequired,
    to: PropTypes.number,
  }).isRequired,
};
